/**
 * Check if Int32 value is negative
 *
 * @param {import('./Int32Type.js').BrandedInt32} value - Value
 * @returns {boolean} True if negative
 */
export function isNegative(value) {
	return value < 0;
}
